<div class="pb-3">
  <h4 class="mb-2" *ngIf="heading">Somme assicurate</h4>

  <resourceful-index
    [hidden]="!index?.customPaginator?.objectsCount"
    #index
    [search]="search"
    [pagination]="false"
    [modelService]="sommaAssicurataService"
    [editFunction]="editFunction"
    [deleteFunction]="deleteFunction"
    [columnDefinitions]="columnDefinitions"
    [relations]="relations"
    [allowHidingColumns]="false"
    (newModelsLoaded)="emitNewModelsLoaded()"
  >
  </resourceful-index>
  <div *ngIf="!index?.customPaginator?.objectsCount">
    Nessuna somma assicurata trovata.
  </div>

  <button type="button" mat-raised-button color="primary" class="mt-4" (click)="add()">
    Aggiungi somma assicurata<mat-icon>add</mat-icon>
  </button>
</div>
